import { GlobalStatus, InvoiceCategoriesEnum, SaleStatusEnum, SoStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";


@Entity('domestic_sales')
export class DomesticSalesEntity {

  @PrimaryGeneratedColumn("increment", { name: 'id' })
  id: number;

  // @PrimaryGeneratedColumn("varchar", { name: 'domestic_sale_order_no' })
  // domesticSaleOrderNo: string;

  @Column("varchar", {
    nullable: false,
    name: "domestic_sale_order_no",
})
domesticSaleOrderNo: string;

  @Column("int", {
    nullable: false,
    name: "customer_id"
  })
  customer: number;

  @Column("int", {
    nullable: false,
    name: "varient_id"
  })
  varient: number;

  @Column("int", {
    nullable: false,
    name: "packStyle_id"
  })
  packStyleId: number;
  
  @Column("int", {
    nullable: true,
    name: "quantity"
  })
  quantity: number;

  @Column("int", {
    nullable: false,
    name: "location_id"
  })
  location: number;

  @Column("int", {
    nullable: false,
    name: "stock_id"
  })
  stockId: number;

  @Column("int", {
    nullable: true,
    name: "unit_price"
  })
  unitPrice: number;

  @Column("decimal", {
    nullable: true,
    name: "tax_id"
  })
  taxId: number;

  @Column("decimal", {
    nullable: true,
    name: "amount"
  })
  amount: number;

  @Column("int", {
    nullable: false,
    name: "cases"
  })
  cases: number;

  @Column("int", {
    nullable: true,
    name: "loose_pouches"
  })
  loosePouches: number;

  @Column("int", {
    nullable: true,
    name: "unit_id"
  })
  unitId: number;

  @CreateDateColumn({
    name: "sale_order_date",
    type: "datetime"
  })
  saleOrderDate: Date;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column('boolean',{
    name:'montly_mis_flag',
    default:0
  })
  montlyMisFlag : boolean

  @Column('boolean',{
    name:'daywise_shrimp_flag',
    default:0
  })
  daywiseShrimpFlag : boolean



}
